import React from "react";
import { Route, Switch } from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route
        path={`${match.url}fractions`}
        component={asyncComponent(() => import('./fractions'))}
      />
      <Route
        path={`${match.url}agenda`}
        component={asyncComponent(() => import('./Agenda'))}
      />
      <Route
        path={`${match.url}dashboard`}
        component={asyncComponent(() => import('./Dashboard'))}
      />
    </Switch>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/routes/index.js